import { render, staticRenderFns } from "./GLMappingView.vue?vue&type=template&id=0de84404"
import script from "./GLMappingView.vue?vue&type=script&lang=js"
export * from "./GLMappingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de84404')) {
      api.createRecord('0de84404', component.options)
    } else {
      api.reload('0de84404', component.options)
    }
    module.hot.accept("./GLMappingView.vue?vue&type=template&id=0de84404", function () {
      api.rerender('0de84404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/glmapping/GLMappingView.vue"
export default component.exports